import { useCallback, useEffect, useState } from "react"
import PantallaCargando from "../../general/pantalla_cargando"
import { toast } from "react-toastify"
import { useDispatch, useSelector } from "react-redux"
import { cerrarSesion } from "../../../redux/actions/session"
import { key_local_storage_cart, urlapi } from "../../../lib/backend/data"
import { Alert, debounce } from "@mui/material"
import { url_images } from "../../../lib/global/data"
import { MdOutlineSecurity } from "react-icons/md"
import { Badge, Button, ButtonGroup, Card, Col, Row, Spinner } from "react-bootstrap"
import { formatoMoneda } from "../../../lib/helpers/main"
import { FaCheckCircle, FaRegClock } from "react-icons/fa";
import ErrorBoundary from "../../errorsHandler/errorBoundary"
import Moment from "react-moment"
import Skeleton from "react-loading-skeleton"
import { default_proveedores } from "../../proveedores_transporte/data"
import { IoIosRadioButtonOff, IoMdRadioButtonOn } from "react-icons/io"
import { IoStorefrontOutline } from "react-icons/io5"

const Flota = (props) => {
    const {
        geo_datos,
        id_orden,
        typeView,
        autoQuote,
        geofencesIds,
        selected,
        code,
        additionalData
    } = props
    const components = {
        resumen: ''
    }
    const estructura = {
        key: "",
    }
    const [ id, setId ] = useState("")
    const [ estructuraActual, setEstructuraActual ] = useState({
        detalles: estructura
    })
    const [ quote, setQuote ] = useState(null)
    const [ error, setError ] = useState(null)
    const [ errorObject, setErrorObject ] = useState(null)
    const carrito = localStorage.getItem(key_local_storage_cart) ? JSON.parse(localStorage.getItem(key_local_storage_cart) ) : []
    let sub_total = carrito.reduce((prev, next) => {
            let cantidad = parseInt(next.cantidad)
            if(isNaN(cantidad)) cantidad = 0
            return prev + (next.precio * cantidad)
          }, 0)
    const sitio = useSelector(state => state.sitio)
    const [ loading, setLoading ] = useState(false)
    const [ tarifas, setTarifas ] = useState([])
    const [ confirmData, setConfirmData ] = useState(null)
    const [ confirmando, setConfirmando ] = useState(false)
    const [ pendienteGuardar, setPendienteGuardar ] = useState(false)
    const [ cotizando, setCotizando ] = useState(false)
    const [ loadingGuardado, setLoadingGuardado ] = useState(false)
    
    const dispatch = useDispatch()

    useEffect(() => {
        cotizarUber()
    }, [])

    const obtenerDatosOrden = async (structure)=>{
        setConfirmando(true)
        return fetch(`${urlapi}/uber/order`,{
            method:'POST',
            body: JSON.stringify({ id_orden }),
            headers: {
                'Content-Type':'application/json',
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
            } else if(res.errorMessage){
                setError(res.errorMessage)
            } else if(res.message){
                setError(res.message)
            } else if(res._id){
                setConfirmData(res)
            } else {
                if(structure?.detalles?.id_customer && structure?.detalles?.secret && structure?.detalles?.origen && autoQuote) cotizarUber() 
            }
            return setConfirmando(false)
        })
        .catch(error => {
            return setConfirmando(false)
        })
    }

    
    const cotizarUber = async ()=>{
        setCotizando(true)
        return fetch(`${urlapi}/shipping/quote`,{
            method:'POST',
            body: JSON.stringify({
                geo_datos, 
                total_cart: sub_total, 
                geofencesIds, 
                propietario: sitio?.propietario
            }),
            headers: {
                'Content-Type':'application/json',
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
            } else if(res.errorMessage){
                setError(res.errorMessage)
            } else if(Array.isArray(res)){
                if(res.length > 0){
                    setTarifas(res)
                    // setQuote(res)
                }
            }
            return setCotizando(false)
        })
        .catch(error => {
            return setCotizando(false)
        })
    }

    const confirmar = async (payload)=>{
        const {
            canal
        } = payload
        setConfirmando(true)
        return fetch(`${urlapi}/${canal}/confirm?id=${id_orden}`,{
            method:'POST',
            body: JSON.stringify({ ...payload }),
            headers: {
                'Content-Type':'application/json',
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
            } else if(res.errorMessage){
                setError(res.errorMessage)
            } else if(res.message){
                setError(res.message)
                if(res.metadata) setErrorObject(res)
            } else if(res?._id){
                if(props.onConfirm) props.onConfirm()
                setConfirmData(res)
            }
            return setConfirmando(false)
        })
        .catch(error => {
            console.log(error.message)
            return setConfirmando(false)
        })
    }
    
    const guardarAutomatico = async (payload)=>{
        setLoadingGuardado(true)
        return fetch(`${urlapi}/configuracion/personalizar`,{
            method:'PUT',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type':'application/json',
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
            } else if(res.errorMessage){
                setError(res.errorMessage)
            }
            setPendienteGuardar(false)
            return setLoadingGuardado(false)
        })
        .catch(error => {
            setPendienteGuardar(false)
            return setLoadingGuardado(false)
        })
    }
    
    const handleChangeExtra = (e, type, campo) => {
        const valor = e.target.value
        if(type === "modulo"){
            const i = estructuraActual.modulos.findIndex(modulo => modulo.slug === campo)
            if( i > -1 ){
                 setPendienteGuardar(true)
                 return setEstructuraActual(prev => {
                    let actual = {...prev}
                    actual.modulos[i].extra = valor
                    actualizar({ _id: id, detalles: actual })
                    return { ...actual }
                 })
            }
        }
    }

    const actualizar = useCallback(debounce((data) => guardarAutomatico(data), 1000), []);

    const handleCheck = (e, type, campo) => {
        const valor = e.target.checked
        if(type === "modulo"){
            const i = estructuraActual.modulos.findIndex(modulo => modulo.slug === campo)
            if( i > -1 ){
                if(estructuraActual.modulos[i].onlyRead === true) return false
                 return setEstructuraActual(prev => {
                    let actual = {...prev}
                    actual.modulos[i].activo = valor
                    actualizar({ _id: id, detalles: actual })
                    return { ...actual }
                 })
            }
        } else if(type === "campos"){
            const i_ = estructuraActual.campos.findIndex(ca => ca.slug === campo)
            if( i_ > -1 ){
                 return setEstructuraActual(prev => {
                    let actual = {...prev}
                    actual.campos[i_].activo = valor
                    actualizar({ _id: id, detalles: actual })
                    return { ...actual }
                 })
            }
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        return setEstructuraActual(prev => {
            let actual = {...prev}
            if(!actual.detalles) actual.detalles = {}
            actual.detalles[name] = value
            actualizar(actual)
            return { ...actual }
        })
    }

    const confirmDataMessage = (type) => {

        if(type === "line") return <Card className="p-2 text-left"><Row>
            <Col xs={1}><img src={`${url_images}/uber.png`} style={{ width: "100%" }} /></Col>
            <Col xs={10}>
            <h6 className="mb-0">CÓDIGO DE CONFIRMACIÓN</h6>
            <Badge variant="dark">{confirmData?.value}</Badge>
            </Col>
        </Row></Card>

        return <div>
            <h4><FaCheckCircle color="green" /> Servicio confirmado</h4>
            <h6 className="mb-0">CÓDIGO DE CONFIRMACIÓN</h6>
            <Badge variant="dark">{confirmData?.value}</Badge>
        </div>
    }

    const seleccionarTarifa = (e) => {
        if(props.onSelect) props.onSelect(e)
    }

    const showDescriptionPickupMethod = (method) => {
        if (!Array.isArray(method.fields)) return false;
        if (method.fields.length === 0) return false;
        
        const i = method.fields.findIndex(f => f.name === "bank_data");
        if (i < 0) return false;

        const field = method.fields[i];
        if (!field?.value) return false;

        // Escapa caracteres especiales y reemplaza \n por <br>
        const escapedValue = field.value
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/\n/g, "<br />");

        return (
            <div
                dangerouslySetInnerHTML={{
                    __html: `<p class="mb-0" style="font-size:11px">${escapedValue}</p>`
                }}
            />
        );
    };

    const showStorePickup = () => {
        if(additionalData?.["Retiro en tienda"]) return <Card md={6} key={`tarifa-retiro`} className="p-2 hover mb-1" onClick={() => seleccionarTarifa(additionalData?.["Retiro en tienda"])} style={{ border: selected?.code === "Retiro en tienda" ? "1px solid black" : "none" }}>
                                <Row className="">
                                <Col lg={2} xs={5}>{ selected?.code === "Retiro en tienda" && 0 === selected?.fee ? <IoMdRadioButtonOn /> : <IoIosRadioButtonOff />}<IoStorefrontOutline className="ml-2" size={30} /></Col>
                                <Col lg={6} xs={8} className="text-left" ><p style={{ fontSize: 11 }} className="mb-0">
                                    <p className="mb-0">Retiro en fábrica</p>
                                    {showDescriptionPickupMethod(additionalData?.["Retiro en tienda"])}</p></Col>
                                <Col lg={4} xs={4} className="text-right" ><h5 className="mb-0">Gratis</h5></Col>
                                    </Row>
                                </Card>
    }
    const mostrarInformacionLinea = () => {
        const logos_providers = default_proveedores.reduce((acc, next) => {
            acc[next.slug] = next.logo
            return acc
        }, {})
                const col_logo = <Col xs={2}>{ selected?.id === code ? <IoMdRadioButtonOn /> : <IoIosRadioButtonOff />}<img src={`${url_images}/uber.png`} style={{ width: "60%" }} /></Col>
        
                const cargando = <Card className="p-2">
                    <Row className="justify-content-center align-items-center">
                        {col_logo}
                        <Col xs={10}><Skeleton count={2} /> </Col>
                    </Row></Card>
        
                if(confirmando || loading) return cargando

                return <div>
                    {
                        tarifas.map((tarifa, i) => {
                            const providerId = tarifa.provider_web ? tarifa.provider_web : tarifa.provider
                            return <Card md={6} key={`tarifa-${i}`} className="p-2 hover mb-1" onClick={() => seleccionarTarifa(tarifa)} style={{ border: selected?.provider === code && tarifa.fee === selected?.fee ? "1px solid black" : "none" }}>
                                <Row className="">
                                {tarifa.provider_web ? <Col lg={2} xs={5}>{ selected?.provider === code && tarifa.fee === selected?.fee ? <IoMdRadioButtonOn /> : <IoIosRadioButtonOff />}<img src={logos_providers[tarifa.provider_web]} className="ml-1" style={{ width: "60%" }} /></Col> : col_logo}
                                <Col lg={6} xs={8} className="text-left" ><p className="mb-0">{tarifa.title}</p></Col>
                                <Col lg={4} xs={4} className="text-right" ><h5 className="mb-0"> {tarifa?.fee ? `CLP ${formatoMoneda(tarifa?.fee)}` : "Gratis" }</h5></Col>
                                    </Row>
                                {additionalData?.[providerId]?.ammount_for_free_shipping > 0 ? <Alert variant="filled" className="mt-2" severity="warning">¡Agrega <b>CLP {formatoMoneda(additionalData?.[providerId]?.ammount_for_free_shipping)}</b> para obtener despacho gratis!</Alert> : false }

                                </Card>
                        })
                    }
                    {showStorePickup()}
                </div>
    }

    const mostrarInformacion = () => {
        if(confirmando) return <div className="d-block text-center"><Spinner animation="border" /></div>
        if(confirmData) return  confirmDataMessage()

        if(!estructuraActual?.detalles?.id_customer || !estructuraActual?.detalles?.secret || !estructuraActual?.detalles?.origen) return false

        return <div>
            <ButtonGroup className="mb-3">
            <Button size="sm" disabled={cotizando} variant="light" onClick={() => cotizarUber()}>{ cotizando ? "BUSCANDO..." : "BUSCAR VEHÍCULO"}</Button>
            {/* <Button size="sm" disabled={cotizando} variant="primary" >CONFIRMAR</Button> */}
            </ButtonGroup>
            { tarifas.length > 0 ? <div>
                <h4>Tarifas encontradas <Badge variant="dark">{formatoMoneda(tarifas.length)}</Badge></h4>
            </div> : false }
            {
                tarifas.map((tarifa, i) => {
                    return <Card md={6} key={`tarifa-${i}`} className="p-2">
                            <Row>
                                <Col xs={9}><Badge className="w-100" variant="primary" style={{ textTransform: "uppercase" }}>ID {tarifa.id}</Badge></Col>
                                <Col xs={3}><Badge className="w-100" variant="dark">{tarifa.duration} Mins.</Badge></Col>
                            </Row>
                            <Row className="mt-3">
                                <Col className="text-left" >
                                <h4 className="mb-0">CLP {formatoMoneda(tarifa?.fee / 100)}</h4>
                                <Badge variant="dark" style={{ fontSize: 11 }} className="text-uppercase"><FaRegClock /> Vence <Moment fromNow>{tarifa.expires}</Moment> </Badge></Col>
                                <Col className="text-right" ><Button disabled={confirmando} size="sm" variant="light" onClick={() => confirmar({ ...tarifa, id_orden, canal: "uber", key: "uber-order-id" })}>CONFIRMAR</Button></Col>
                            </Row>
                        </Card>
                })
            }
        </div>
    }

    
    if(typeView === "line") return mostrarInformacionLinea()
    
    if(loading) return <PantallaCargando />


    return <div>
        {/* <img src={`${url_images}/uber.png`} style={{ height: 50, marginBottom: 10 }} /> */}
        {mostrarInformacion()}
        <ErrorBoundary message={error} jsonData={errorObject} />
    </div>
}

export default Flota